import Inputmask from 'inputmask';

const inputMaskPlugin = {
  install: (Vue) => {
    Vue.directive('inputmask', {
      bind: (el, binding) => {
        Inputmask(binding.value).mask(el);
      },
    });
  },
};

export default inputMaskPlugin;
